import Vue, { PropType } from 'vue';

interface SettingsInterface {
  componentName?: string;
  nameOfRemoved?: string;
}

interface FormDataInterface {
  id: number;
}

interface DeleteItemInterface {
  (formData: FormDataInterface): void;
}

interface HeaderInterface {
  (header: string): void;
}

const ConfirmDeleteElementComponent = Vue.extend({
  props: {
    header: {
      type: Function as PropType<HeaderInterface>,
      required: true,
    },
    closeModal: {
      type: Function as PropType<() => void>,
      required: true,
    },
    deleteItem: {
      type: Function as PropType<DeleteItemInterface>,
      required: true,
    },
    formData: {
      type: Object as PropType<FormDataInterface>,
    },
    settings: {
      type: Object as PropType<SettingsInterface>,
      required: false,
    },
  },

  mounted(): void {
    let textHeader = 'Delete ';

    if (typeof this.settings === 'undefined') {
      this.header('Confirm deletion');
      this.textConfirm += ' ?';

      return;
    }

    if (this.hasComponentName) {
      this.textConfirm += this.settings.componentName;
      textHeader += this.settings.componentName;
    }
    if (this.hasNameOfRemoved) {
      this.textConfirm += ` ${this.settings.nameOfRemoved}`;
      textHeader += ` ${this.settings.nameOfRemoved}`;
    }
    this.textConfirm += ' ?';
    this.header(textHeader);
  },

  data() {
    return {
      name: 'ConfirmDeleteElementComponent',
      textConfirm: 'Are you sure you want to delete ',
    };
  },

  computed: {
    hasComponentName(): boolean {
      return typeof this.settings.componentName !== 'undefined'
        && this.settings.componentName !== '';
    },
    hasNameOfRemoved(): boolean {
      return typeof this.settings.nameOfRemoved !== 'undefined'
        && this.settings.nameOfRemoved !== '';
    },
  },

  methods: {
    remove(): void {
      this.deleteItem(this.formData);
      this.closeModal();
    },
  },
});

export default ConfirmDeleteElementComponent;
